export default __webpack_public_path__ + "static/media/elan_insta.8b5acce8.png";